import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getLoyaltyReport,
    getLoyaltyReportCustomer,
    getLoyaltyReportReward,
    getEarningByCustomer,
} from '../../services/api';

export const fetchStoreReport = createAsyncThunk(
    'loyaltyReports/fetchStore',
    async ({ perPage, page }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyReport(perPage, page);
            const data = response.data;
            return { items: data.data || data, totalPages: data.last_page };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

export const fetchCustomerReport = createAsyncThunk(
    'loyaltyReports/fetchCustomer',
    async ({ perPage, page }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyReportCustomer(perPage, page);
            const data = response.data;
            return { items: data.data || data, totalPages: data.last_page };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

export const fetchRewardReport = createAsyncThunk(
    'loyaltyReports/fetchReward',
    async ({ perPage, page }, { rejectWithValue }) => {
        try {
            const response = await getLoyaltyReportReward(perPage, page);
            const data = response.data;
            return { items: data.data || data, totalPages: data.last_page };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

export const fetchEarningByCustomer = createAsyncThunk(
    'loyaltyReports/fetchEarning',
    async ({ perPage, page, filters }, { rejectWithValue }) => {
        try {
            const response = await getEarningByCustomer(perPage, page, filters);
            const data = response.data;
            return { items: data.data || data, totalPages: data.last_page };
        } catch (err) {
            return rejectWithValue(err.message || 'Failed to fetch Loyalty Card');
        }
    }
);

const emptyReport = () => ({ items: [], loading: true, error: '', totalPages: 1 });

const loyaltyReportsSlice = createSlice({
    name: 'loyaltyReports',
    initialState: {
        store: emptyReport(),
        customer: emptyReport(),
        reward: emptyReport(),
        earning: emptyReport(),
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchStoreReport.pending, (state) => { state.store.loading = true; })
            .addCase(fetchStoreReport.fulfilled, (state, action) => {
                state.store.items = action.payload.items;
                state.store.totalPages = action.payload.totalPages;
                state.store.loading = false;
            })
            .addCase(fetchStoreReport.rejected, (state, action) => {
                state.store.error = action.payload;
                state.store.loading = false;
            })

            .addCase(fetchCustomerReport.pending, (state) => { state.customer.loading = true; })
            .addCase(fetchCustomerReport.fulfilled, (state, action) => {
                state.customer.items = action.payload.items;
                state.customer.totalPages = action.payload.totalPages;
                state.customer.loading = false;
            })
            .addCase(fetchCustomerReport.rejected, (state, action) => {
                state.customer.error = action.payload;
                state.customer.loading = false;
            })

            .addCase(fetchRewardReport.pending, (state) => { state.reward.loading = true; })
            .addCase(fetchRewardReport.fulfilled, (state, action) => {
                state.reward.items = action.payload.items;
                state.reward.totalPages = action.payload.totalPages;
                state.reward.loading = false;
            })
            .addCase(fetchRewardReport.rejected, (state, action) => {
                state.reward.error = action.payload;
                state.reward.loading = false;
            })

            .addCase(fetchEarningByCustomer.pending, (state) => { state.earning.loading = true; })
            .addCase(fetchEarningByCustomer.fulfilled, (state, action) => {
                state.earning.items = action.payload.items;
                state.earning.totalPages = action.payload.totalPages;
                state.earning.loading = false;
            })
            .addCase(fetchEarningByCustomer.rejected, (state, action) => {
                state.earning.error = action.payload;
                state.earning.loading = false;
            });
    },
});

export default loyaltyReportsSlice.reducer;
